import { render, staticRenderFns } from "./CodeBox.vue?vue&type=template&id=3c4c5c7f&scoped=true&"
import script from "./CodeBox.vue?vue&type=script&lang=js&"
export * from "./CodeBox.vue?vue&type=script&lang=js&"
import style0 from "./CodeBox.vue?vue&type=style&index=0&id=3c4c5c7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c5c7f",
  null
  
)

export default component.exports